import { HStack, Text, VStack, Icon, Center, Link } from '@chakra-ui/react';
import { FaDiscord, FaTelegram, FaTiktok, FaXTwitter } from 'react-icons/fa6';
import { RiInstagramFill } from 'react-icons/ri';

export default function Footer() {
  return (
    <VStack w="100%" align="center" p="3" zIndex="2" spacing="4">
      <HStack spacing="4">
        <Center as={Link} href="https://x.com/exeedme" target="_blank" cursor="pointer">
          <Icon as={FaXTwitter} />
        </Center>
        <Center as={Link} href="https://discord.gg/exeedme" target="_blank" cursor="pointer">
          <Icon as={FaDiscord} />
        </Center>
        <Center as={Link} href="https://t.me/exeedme" target="_blank" cursor="pointer">
          <Icon as={FaTelegram} />
        </Center>
        <Center as={Link} href="https://www.instagram.com/exeedme" target="_blank" cursor="pointer">
          <Icon as={RiInstagramFill} />
        </Center>
        <Center
          as={Link}
          href="https://www.tiktok.com/@exeedme.official"
          target="_blank"
          cursor="pointer"
        >
          <Icon as={FaTiktok} />
        </Center>
      </HStack>
      <Text fontSize="md">Exeedme © {new Date().getFullYear()}</Text>{' '}
    </VStack>
  );
}
